<template>
   <div :class="regionInputClass">
        <label class="input__label" for="canvasser-regions-field" v-html="$t('REGIONAL_FIELD_TEAM')"></label>
        <multiselect
            v-if="regions.length"
            v-model="region"
            track-by="id"
            id="canvasser-regions-field"
            label="name"
            placeholder="Please select an area"
            openDirection="below"
            :allow-empty="false"
            :options="regions">
        </multiselect>

        <!-- Validation -->
        <p class="input__message" v-if="showRegionRequiredValidationMessage"
           v-html="$t('REGIONAL_FIELD_SELECT')"></p>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import required from 'vuelidate/src/validators/required';
import RegionService from '@/services/canvassers/RegionService';

let regionService = new RegionService();

export default {
    name: 'RegionsField',
    props: {
        value: {
            default: null,
            type: Object,
        },
    },
    data() {
        return {
            region: null,
            regions: [],
        };
    },
    computed: {
        regionInputClass() {
            if (this.region === null) return 'input';

            return this.isRegionValid ? 'input input--success' : 'input input--invalid';
        },

        isRegionValid() {
            return !this.$v.region.$invalid;
        },

        showRegionRequiredValidationMessage() {
            return this.region !== null && !this.$v.region.required;
        },
    },
    mounted() {
        this.getRegions();
    },
    methods: {
        /**
         * Get the canvasser regions.
         *
         * @returns {void}
         */
        getRegions() {
            regionService.getRegions()
                .then(response => { this.regions = response.data.data; });
        },

        /**
         * Sync with parent component.
         *
         * @returns {void}
         */
        updateInput() {
            this.$v.$touch();

            this.$emit('input', this.region);
        },

        /**
         * Update region from prop.
         *
         * @param {Object} value
         *
         * @returns {void}
         */
        updateRegion(value) {
            this.region = value;
        },
    },
    validations: {
        region: {
            required,
        },
    },
    watch: {
        region() {
            this.updateInput();
        },
        value: {
            handler(newValue) {
                if (newValue !== this.region) {
                    this.updateRegion(newValue);
                }
            },
            immediate: true,
        },
    },
    components: {
        Multiselect,
    },
};
</script>
